import gql from 'graphql-tag';

import type { BlogPostBuilderBrief } from 'src/data/blog';
import type { Language } from 'src/data/generation';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BLOG_POST_BUILDER_BRIEF } from './schema';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderLanguage($id: ID!, $language: String!) {
    updateBlogPostBuilderLanguage(id: $id, language: $language) {
      ...BlogPostBuilderBrief
    }
  }
  ${FRAGMENT_BLOG_POST_BUILDER_BRIEF}
`;

interface Variables extends GqlCallVariables {
  id: ID;
  language: Language;
}

export const updateBlogPostBuilderLanguage = async (
  variables: Variables
): Promise<BlogPostBuilderBrief | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<BlogPostBuilderBrief>(result.data);
};
